import React from "react";
import rod2 from "../../Asset/9153.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import project2 from "../../Asset/12502029_35.jpg";
import project3 from "../../Asset/12502029_35.jpg";
import banner from "../../Asset/ABOUT US BANNER_UPDATED.png";
import mission from "../../Asset/213.jpg";
import policies from "../../Asset/policies-checklists.jpg";
import vission from "../../Asset/Structural-steel.jpg";

const AboutUs = () => {
  return (
    <div className="w-full bg-white">
      {/* Hero Section */}
      <section className="w-full">
        <img src={banner} alt="About Us Banner" className="w-full h-auto object-cover" />
      </section>

      {/* About Us Section */}
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-4 py-10 gap-8">
        <div className="w-full lg:w-1/2">
          <img src={rod2} alt="Award Ceremony" className="w-full h-auto" />
        </div>
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="text-2xl lg:text-3xl font-bold text-[#114497]">About Us</h2>
          <p className="text-gray-700 text-md mt-4">
            Since 2014, the Sai Steel Group has built a name that resonates with trust, quality, and commitment across India.
            Under the visionary leadership of CEO Er. Saravanan Lakshmanan, our journey has been one of innovation,
            excellence, and deep-rooted passion for engineering.
          </p>
          <p className="text-gray-700 text-md mt-4">
            Established in 2014, Sai Steel has been at the heart of Vellore infrastructure growth, empowering ambitious
            construction projects with superior-grade materials and expert solutions. From TMT rods, cement to premium
            paints, roofing essentials, our range reflects a dedication to durability, precision, and performance.
          </p>
          <p className="text-gray-700 text-md mt-4">
            Driven by an engineering mindset and powered by cutting-edge technology, we don’t just supply materials.
          </p>
        </div>
      </div>
      
      {/* Mission Section */}
      <div className="bg-[#fbb613] text-[#114497] flex flex-col lg:flex-row items-center">
        <div className="w-full lg:w-1/2 p-6 md:p-12 lg:p-20">
          <h3 className="text-2xl lg:text-3xl font-bold">OUR MISSION</h3>
          <p className="mt-4 text-md">
            At Sai Steel, our mission is to deliver high-quality construction materials that not only meet but exceed international standards.
            We are committed to upholding a legacy of integrity, consistency, and exceptional customer satisfaction in every product and partnership.
          </p>
          <p className="mt-4 text-md">
            With a strong focus on continuous innovation and the adoption of cutting-edge technology, we strive to remain at the forefront of
            the construction industry. By empowering our clients, teams, and partners, we aim to contribute to India’s infrastructure growth
            by building structures that are stronger, safer, and smarter.
          </p>
        </div>
        <div className="w-full lg:w-1/2">
          <img src={mission} alt="Our Mission" className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Vision Section */}
      <div className="bg-[#114497] text-white flex flex-col lg:flex-row items-center">
        <div className="w-full lg:w-1/2">
          <img src={vission} alt="Our Vision" className="w-full h-full object-cover" />
        </div>
        <div className="w-full lg:w-1/2 p-6 md:p-12 lg:p-20">
          <h3 className="text-2xl lg:text-3xl font-bold text-[#fbb613]">OUR VISION</h3>
          <p className="mt-4 text-md">
            To be India’s most trusted and innovative brand in construction materials, empowering infrastructure with strength,
            precision, and sustainability. We aim to set new benchmarks in the steel industry by integrating cutting-edge technology,
            ensuring top-tier quality, and maintaining an unwavering commitment to ethical business practices.
          </p>
          <p className="mt-4 text-md">
            We envision a future where every structure built with Sai Steel products stands as a symbol of quality, reliability,
            and engineering excellence—contributing to the nation's growth through enduring and intelligent construction.
          </p>
        </div>
      </div>

      {/* Policies Section */}
      <div className="bg-white flex flex-col lg:flex-row items-center px-4 py-10 gap-8">
        <div className="w-full lg:w-1/2 p-6 md:p-12 lg:p-20">
          <h3 className="text-2xl lg:text-3xl font-bold text-[#114497]">OUR POLICIES</h3>
          <p className="mt-4 text-md">
            At Sai Steel, we are committed to maintaining the highest standards of excellence in every aspect of our operations.
            Our policies are aimed at achieving and sustaining perfection from raw material procurement to production and delivering
            the final products to our customers.
          </p>
          <p className="mt-4 text-md">
            <strong className="text-black">Quality Assurance: </strong>Every product undergoes rigorous testing to ensure it meets
            national and international standards. We prioritize quality control to guarantee the safety and longevity of our steel solutions.
          </p>
          <p className="mt-4 text-md">
            <strong className="text-black">Ethical Business Practices: </strong>Transparency, honesty, and fairness define our
            relationships with clients, employees, and stakeholders.
          </p>
          <p className="mt-4 text-md">
            <strong className="text-black">Customer Satisfaction: </strong>We continuously innovate to meet evolving customer needs,
            ensuring reliable supply chains, competitive pricing, and exceptional service.
          </p>
          <p className="mt-4 text-md">
            <strong className="text-black">Employees Welfare: </strong>We value our workforce and are dedicated to providing a safe,
            inclusive, and growth-oriented work environment.
          </p>
          <p className="mt-4 text-md">
            <strong className="text-black">Enduring Growth: </strong>We strive for long-term growth by embracing innovation, adopting
            sustainable practices, and building resilient business models that withstand market challenges and evolve with industry trends.
          </p>
        </div>
        <div className="w-full lg:w-1/2">
          <img src={policies} alt="Policies" className="w-full h-full object-cover " />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
